export default __webpack_public_path__ + "static/media/white-cam-3.7da08211.png";